import styled from 'styled-components';

import { RemoveIc } from '@dsch/dd-icons';

import { ButtonLink } from '../../../../components/Toolkit/Button/ButtonLink';
import { Notification } from '../../../../components/Toolkit/Notification/Notification';
import { DetailList } from '../../../../components/Toolkit/DetailList/DetailList';
import { media } from '../../../../helpers/breakpoints';
import { PAGE } from '../../../../helpers/pages';
import {
  SummaryPanel,
  SummaryWrapper,
} from '../../../../components/CarValuationPage/components/CarSummaryPanel/CarSummaryPanel';
interface IErrorSummaryPanel {
  registration: string;
  pageName: string;
}

export const PageWrapper = styled.div<{ pageName: string }>`
  margin: 0 auto;
`;

const Wrapper = styled.div`
  position: relative;
  margin: ${({ theme }) => `0 0 ${theme.spacing.L40} 0`};
`;

const SummaryPanelWrapper = styled.div`
  background: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  z-index: 1;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.M24} ${theme.spacing.M16}`};
  margin: 0 auto;

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
    max-width: 760px;
  }
`;

const PanelContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  ${media.large} {
    max-width: 448px;
  }
`;

const VehicleInformation = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const Registration = styled.p`
  ${({ theme }) => theme.fontSize.M14};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const SNotification = styled(Notification)`
  color: ${({ theme }) => theme.colors.GREY_DARK};
  padding: ${({ theme }) => ` ${theme.spacing.S8} `};
  justify-content: left;
  text-align: left;

  p {
    ${({ theme }) => theme.fontSize.B12};
  }
`;

const AssumptionList = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  width: 100%;

  ${media.large} {
    max-width: 760px;
  }
`;

const Title = styled.div`
  ${({ theme }) => theme.fontSize.M16}
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  text-align: left;
`;

const SDetailList = styled(DetailList)`
  row-gap: ${({ theme }) => theme.spacing.M16};
`;

const SIoRemove = styled(RemoveIc)`
  color: ${({ theme }) => theme.colors.GREY};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.M16};
`;

const SButtonLink = styled(ButtonLink)`
  flex: 50%;
  margin: 0 auto;
  width: 240px;
`;

const TextWrapper = styled.div`
  margin: ${({ theme }) => `0 auto ${theme.spacing.M32}`};

  h1 {
    ${({ theme }) => theme.fontSize.H24}

    color: ${({ theme }) => theme.colors.WHITE};
    max-width: 290px;
    margin: 0 auto;
    text-align: center;

    ${media.large} {
      ${({ theme }) => theme.fontSize.H32}
      max-width: 592px;
    }
  }

  ${media.large} {
    margin: ${({ theme }) => `232px auto ${theme.spacing.M32}`};
  }
`;

function ErrorSummaryPanel({
  registration = '',
  pageName,
}: IErrorSummaryPanel) {
  return (
    <SummaryWrapper>
      <SummaryPanel pageName={pageName}>
        <Wrapper>
          <TextWrapper>
            <h1>
              {pageName === PAGE.INSTANT_OFFER_VALUATION
                ? 'Get the best offer from a trusted dealership and sell your car hassle-free'
                : 'How much is your car worth right now?'}
            </h1>
          </TextWrapper>

          <SummaryPanelWrapper>
            <PanelContainer>
              <VehicleInformation>
                {pageName === PAGE.PRIVATE_VALUATION && (
                  <Registration>Your registration: {registration}</Registration>
                )}
                <SNotification intent="ERROR" className="large-half">
                  We couldn't provide a valuation for your vehicle
                </SNotification>
              </VehicleInformation>
              <AssumptionList>
                <Title>This can happen for a number of reasons:</Title>
                <SDetailList
                  singleColumnOnDesktop={true}
                  list={[
                    'You entered an invalid registration number',
                    'Your car does not have an Irish registration',
                    'Your car is greater than 10 years old',
                    "There's not enough data to value your car",
                    'Your vehicle is not a car',
                    "You're not logged-in to DoneDeal",
                  ].map((assumption) => ({
                    title: assumption,
                    icon: <SIoRemove width="16" height="16" />,
                  }))}
                />
              </AssumptionList>

              <ButtonGroup>
                <SButtonLink
                  href={
                    pageName === PAGE.INSTANT_OFFER_VALUATION
                      ? '/instant-offer'
                      : '/value-my-car'
                  }
                  ofType="SECONDARY"
                >
                  Try Again
                </SButtonLink>
              </ButtonGroup>
            </PanelContainer>
          </SummaryPanelWrapper>
        </Wrapper>
      </SummaryPanel>
    </SummaryWrapper>
  );
}

export { ErrorSummaryPanel };
